@if (couponEvents.length) {
    <div class="coupon-container">
        @for (coupon of couponEvents; track trackById(i, coupon.events[i]); let i = $index) {
            <accordion [accordionTitle]="coupon.typeName" [isExpanded]="true" class="goalscorer-coupon" data-crlat="league">
                <accordion-body>
                    <div class="odds-card-header" data-crlat="eventOddsHeader">
                        <div class="odds-left">&nbsp;</div>
                        <div class="odds-right">
                            @for (title of headers; track title) {
                                <span class="odds-header-col" data-crlat="headTitles" [textContent]="title"></span>
                            }
                        </div>
                    </div>
                    @for (event of coupon.events; track trackById(i, event); let i = $index) {
                        <div class="odds-card" [dataEventid]="event.id" data-crlat="oddsCard.sportTemplate">
                            <div class="odds-content odds-content-panel">
                                @if (!isArrowHide(event)) {
                                    <div class="odds-right">
                                        <div
                                            class="select-arrow"
                                            [class.disabled]="isDisabled(event, 'teamH', true)"
                                            (click)="onScoreChange(1, 'teamH', event, true)">
                                            <svg class="arrow-top">
                                                <use xlink:href="#down-arrow"></use>
                                            </svg>
                                        </div>
                                        <div
                                            class="select-arrow"
                                            [class.disabled]="isDisabled(event, 'teamA', true)"
                                            (click)="onScoreChange(1, 'teamA', event, true)">
                                            <svg class="arrow-top">
                                                <use xlink:href="#down-arrow"></use>
                                            </svg>
                                        </div>
                                        <div class="select-arrow"></div>
                                    </div>
                                }
                            </div>
                            <div class="odds-content" data-crlat="oddsContent">
                                <div class="odds-left" data-crlat="oddsLeft">
                                    <div class="odds-names odds-names-list" data-crlat="oddsNames">
                                        <span class="odds-normal" data-crlat="playerName" [textContent]="event.teams?.teamH?.name"></span>
                                        <span class="odds-normal" data-crlat="playerName" [textContent]="event.teams?.teamA?.name"></span>
                                    </div>
                                </div>
                                <div class="odds-right" data-crlat="oddsRight">
                                    <div class="odds-btn-content" data-crlat="oddsBtnContent" (click)="$event.stopPropagation()">
                                        @if (!isSuspended(event)) {
                                            <div class="odds-btn-wrapper">
                                                <select
                                                    class="odds-select"
                                                    data-crlat="maxValues.homeTeam"
                                                    [disabled]="event.isActive"
                                                    (change)="onScoreChange($event.target.value, 'teamH', event)">
                                                    <option
                                                        *ngFor="let score of event?.teams?.teamH?.scores; trackBy: trackById"
                                                        [selected]="score === event.teams.teamH.score"
                                                        [textContent]="score"></option>
                                                </select>
                                            </div>
                                        }
                                        @if (!isSuspended(event)) {
                                            <div class="odds-btn-wrapper">
                                                <select
                                                    class="odds-select"
                                                    data-crlat="maxValues.homeTeam"
                                                    [disabled]="event.isActive"
                                                    (change)="onScoreChange($event.target.value, 'teamA', event)">
                                                    <option
                                                        *ngFor="let score of event?.teams?.teamA?.scores; trackBy: trackById"
                                                        [selected]="score === event.teams.teamA.score"
                                                        [textContent]="score"></option>
                                                </select>
                                            </div>
                                        }
                                        <div class="odds-btn-wrapper">
                                            @if (!isHide(event) && !event.isDelay) {
                                                <price-odds-button
                                                    [event]="event"
                                                    [market]="event.markets[0]"
                                                    [outcome]="event.combinedOutcomes"
                                                    data-crlat="combinedOutcome">
                                                </price-odds-button>
                                            }
                                            @if (isHide(event) && !event.isDelay) {
                                                <button [disabled]="true" class="btn btn-bet" data-crlat="betButton">
                                                    <span>N/A</span>
                                                </button>
                                            }
                                            @if (event.isDelay) {
                                                <button [disabled]="true" class="btn btn-bet btn-bet-spinner" data-crlat="betButton">
                                                    <span class="spinner-loader small-loader spinner-dark" data-crlat="spinner.loader"></span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="odds-content odds-content-panel">
                                <div class="odds-left">
                                    <span class="odds-time" [textContent]="event.time"></span>
                                </div>
                                @if (!isArrowHide(event)) {
                                    <div class="odds-right">
                                        <div
                                            class="select-arrow"
                                            [class.disabled]="isDisabled(event, 'teamH', false)"
                                            (click)="onScoreChange(-1, 'teamH', event, true)">
                                            <svg class="arrow-bottom">
                                                <use xlink:href="#down-arrow"></use>
                                            </svg>
                                        </div>
                                        <div
                                            class="select-arrow"
                                            [class.disabled]="isDisabled(event, 'teamA', false)"
                                            (click)="onScoreChange(-1, 'teamA', event, true)">
                                            <svg class="arrow-bottom">
                                                <use xlink:href="#down-arrow"></use>
                                            </svg>
                                        </div>
                                        <div class="select-arrow"></div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </accordion-body>
            </accordion>
        }
    </div>
}
